import React, { useEffect } from 'react';
import { Nav } from './nav.tsx';
import { Footer } from './footer.tsx';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import i18next from 'i18next';

export function Partners() {
    const { lang } = useParams();
    const { t } = useTranslation();
    const baseURL = "https://www.parlaretail.com";
    useEffect(() => {
        if (lang) {
            i18next.changeLanguage(lang);
        }
    }, [lang]);

    return (<>
        <Helmet key={lang}>
            {/* General Meta */}
            <meta charSet="utf-8" />
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
            <title>{t('integrations.meta.title')}</title>
            <meta name="description" content={t('integrations.meta.description')} />
            <meta name="keywords" content={t('integrations.meta.keywords')} />
            <meta name="viewport" content="width=device-width, initial-scale=1" />

            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={t('integrations.meta.title')} />
            <meta property="og:description" content={t('integrations.meta.description')} />
            <meta property="og:url" content={`${baseURL}/${lang}/`} />
            <meta property="og:image" content={`${baseURL}/img/sharing-image.jpg`} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={t('integrations.meta.title')} />
            <meta name="twitter:description" content={t('integrations.meta.description')} />
            <meta name="twitter:image" content={`${baseURL}/img/sharing-image.jpg`} />

            {/* Hreflang for Language Versioning */}
            <link rel="alternate" hrefLang="en" href={`${baseURL}/en/`} />
            <link rel="alternate" hrefLang="es" href={`${baseURL}/es/`} />

            {/* Favicon */}
            <link rel="icon" type="image/png" href={`${baseURL}/img/parla-fav.png`} />
        </Helmet>
        <Nav />
        <div className="page">
            {/* Integrations Section */}
            <div className="section-column partners">
                <div className="row f70 t-center t-color-2 p20">{t('integrations.title')}</div>
                <div className="text-info-panel w80 p40 t-center">{t('integrations.description')}</div>
                <div className="card-holder w80 ptb-50">
                    <div className="row">
                        Partners Form
                    </div>
                </div>
                <div className="btn-wrap mb50">
                    <a href="contact-partners.html" className="btn btn-dark">
                        {t('integrations.button')}
                    </a>
                </div>
            </div>
        </div>
        <Footer />
    </>
    );
}